import React, { useEffect, useRef, useState } from "react";
import { axisBottom, select } from "./assets/d3";
import "./BottomAxis.scss";
const INITIAL_LABEL_WIDTH = 120;
export const BottomAxis = ({ scale, width, height, formatter = (value) => value.toString(), }) => {
    const axisRef = useRef(null);
    const [maxLabelWidth, setMaxLabelWidth] = useState(INITIAL_LABEL_WIDTH);
    useEffect(() => {
        const axis = axisBottom(scale)
            .ticks(Math.floor(width / (2 * maxLabelWidth)))
            .tickFormat(formatter);
        select(axisRef.current).call(axis);
        const maxLabel = Math.max(...Array.from(axisRef.current.querySelectorAll("text")).map((item) => item.scrollWidth));
        if (maxLabel !== maxLabelWidth && maxLabel !== 0 && width !== 0) {
            setMaxLabelWidth(maxLabel);
        }
    }, [width, height, scale, maxLabelWidth]);
    return (React.createElement("div", { className: "focus-bottom-axis", style: { height: `${2 * (height / 3)}px` } },
        React.createElement("svg", { width: width },
            React.createElement("g", { ref: axisRef, role: "axis" }))));
};
//# sourceMappingURL=BottomAxis.js.map